import React from "react";
import styles from "./tool-btn.module.scss";
import classNames from "classnames";
import { motion } from "framer-motion";

type Props = {
  children: React.ReactNode;
  onClick: () => void;
  clear?: boolean;
  className?: string;
  title?: string;
};

const ToolBtn = ({ children, onClick, clear = false, className, title }: Props) => {
  return (
    <motion.button
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className={classNames(styles.toolBtn, clear && styles.clear, className)}
      onClick={onClick}
      title={title}
    >
      {children}
    </motion.button>
  );
};

export default ToolBtn;
